import React, { Component } from "react";
import FollowupList from "../../components/Follwup/Followuplist";

class Followup extends Component {
  render() {
    return (
      <div>
        <FollowupList />
      </div>
    );
  }
}

export default Followup;
